import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  api,
  type PromoCodeItem,
  type CreatePromoCodeData,
} from '../api/client';

export function usePromoCodes() {
  return useQuery<PromoCodeItem[]>({
    queryKey: ['admin', 'promo-codes'],
    queryFn: () => api.promoCodes.list(),
  });
}

export function useCreatePromoCode() {
  const queryClient = useQueryClient();
  return useMutation<PromoCodeItem, Error, CreatePromoCodeData>({
    mutationFn: (data) => api.promoCodes.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'promo-codes'] });
    },
  });
}

export function useDeactivatePromoCode() {
  const queryClient = useQueryClient();
  return useMutation<PromoCodeItem, Error, string>({
    mutationFn: (id) => api.promoCodes.deactivate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'promo-codes'] });
    },
  });
}
